import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { pointsConfig } from "../../../../pointsConfig";
import MilesRankDetailModalHeader from "./MilesRankDetailModalHeader";
import MilesRankDetailModalStatsSection from "./MilesRankDetailModalStatsSection";
import MilesRankDetailBadgesSection from "./MilesRankDetailBadgesSection";

const style = {
  position: "absolute",
  top: "50%",
  right: "0%",
  transform: "translate(0%, -50%)",
  width: window.innerWidth > 600 ? "40vw" : "100vw",
  bgcolor: "background.paper",
  boxShadow: 24,
};

export default function MilesRankDetailModal({ open, setOpen }) {
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="flex flex-col font-main h-screen">
            <div className="flex flex-1 flex-col overflow-scroll scroll-hide relative">
              {/* Header */}
              <MilesRankDetailModalHeader />
              <div className="flex w-full p-4 flex-col">
                <MilesRankDetailModalStatsSection />
                <MilesRankDetailBadgesSection />
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
